export default function IconA1() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path
                d="M29.8125 6.75H6.1875C5.25552 6.75 4.5 7.50552 4.5 8.4375V26.4375C4.5 27.3695 5.25552 28.125 6.1875 28.125H29.8125C30.7445 28.125 31.5 27.3695 31.5 26.4375V8.4375C31.5 7.50552 30.7445 6.75 29.8125 6.75Z"
                stroke="#707070"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.25 6.75L11.25 28.125" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 6.75V28.125" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24.75 6.75V28.125" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24.75 11.25H27" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 11.25H20.25" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.25 11.25H13.5" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="7.875" cy="23.625" r="1.125" fill="#707070" />
        </svg>
    );
}
